import { render, staticRenderFns } from "./VocabularyMemoRus.vue?vue&type=template&id=0ea8f621&lang=pug&"
import script from "./VocabularyMemoRus.vue?vue&type=script&lang=js&"
export * from "./VocabularyMemoRus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports